  import React, { useRef, useEffect } from "react";
  import { ThemeProvider, createTheme, CssBaseline, Box, keyframes } from "@mui/material";
  import { useThemeMode } from "./ThemeModeContext";

  const fadeLightToDark = keyframes`
    0% {
      background-color: #FAF5E4;
    }
    50% {
      background-color: #6D6D6D;
    }
    100% {
      background-color: #121212;
    }
  `;

  const fadeDarkToLight = keyframes`
    0% {
      background-color: #121212;
    }
    50% {
      background-color: #6D6D6D;
    }
    100% {
      background-color: #FAF5E4;
    }
  `;

  const ThemeProviderWrapper = ({ children }) => {
    const { mode } = useThemeMode();

    // pra sabermos o modo anterior
    const prevModeRef = useRef(mode);
    useEffect(() => {
      prevModeRef.current = mode;
    }, [mode]);

    const theme = React.useMemo(() => {
      return createTheme({
        palette: {
          mode,
          background: {
            default: mode === "light" ? "#FAF5E4" : "#121212",
            paper: mode === "light" ? "#FFFFFF" : "#1E1E1E",
          },
          text: {
            primary: mode === "light" ? "#1A202C" : "#FFFFFF",
          },
        },
      });
    }, [mode]);

    // Se modo atual é 'dark' e modo anterior era 'light', anima de light->dark
    // Se modo atual é 'light' e modo anterior era 'dark', anima de dark->light
    let animationName = "none";
    if (mode === "dark" && prevModeRef.current === "light") {
      animationName = `${fadeLightToDark}`;
    } else if (mode === "light" && prevModeRef.current === "dark") {
      animationName = `${fadeDarkToLight}`;
    }

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            // define manualmente a cor final pra ficar coerente com o theme
            bgcolor: "background.default",
            color: "text.primary",
            // animação via keyframes
            animation: `${animationName} 2s forwards`,
            minHeight: "100vh",
          }}
        >
          {children}
        </Box>
      </ThemeProvider>
    );
  };

  export default ThemeProviderWrapper;
